function normalizeLocationName(value) {
  return String(value || "")
    .toLocaleLowerCase("bg-BG")
    .replace(/[„“"'’]/g, "")
    .replace(/[^a-zа-я0-9]+/gi, " ")
    .trim()
    .replace(/^(фирма|компания|проект|обект|подобект|част)\s+/, "");
}

function editDistance(leftValue, rightValue) {
  const left = String(leftValue || "");
  const right = String(rightValue || "");
  const previous = Array.from(
    { length: right.length + 1 },
    (value, index) => index
  );

  for (let leftIndex = 1; leftIndex <= left.length; leftIndex += 1) {
    const current = [leftIndex];

    for (
      let rightIndex = 1;
      rightIndex <= right.length;
      rightIndex += 1
    ) {
      const substitutionCost =
        left[leftIndex - 1] === right[rightIndex - 1] ? 0 : 1;
      current[rightIndex] = Math.min(
        current[rightIndex - 1] + 1,
        previous[rightIndex] + 1,
        previous[rightIndex - 1] + substitutionCost
      );
    }

    previous.splice(0, previous.length, ...current);
  }

  return previous[right.length];
}

function fuzzyCandidates(target, candidates) {
  return candidates
    .map((candidate) => {
      const distance = editDistance(target, candidate.normalizedName);
      const comparedLength = Math.max(
        target.length,
        candidate.normalizedName.length
      );
      const similarity =
        comparedLength > 0 ? 1 - distance / comparedLength : 0;
      const allowedDistance = Math.min(
        3,
        Math.floor(comparedLength * 0.2)
      );

      return {
        ...candidate,
        distance,
        similarity,
        allowedDistance,
      };
    })
    .filter((candidate) => {
      return (
        candidate.allowedDistance >= 1 &&
        candidate.distance <= candidate.allowedDistance &&
        candidate.similarity >= 0.8
      );
    })
    .sort((left, right) => {
      if (left.distance !== right.distance) {
        return left.distance - right.distance;
      }
      return right.similarity - left.similarity;
    });
}

export function findAiLocationMatch(
  value,
  options,
  nameKey,
  locationLabel
) {
  const target = normalizeLocationName(value);
  const candidates = (Array.isArray(options) ? options : [])
    .map((option) => ({
      option,
      normalizedName: normalizeLocationName(option[nameKey]),
    }))
    .filter((candidate) => candidate.normalizedName);
  const exactMatches = candidates.filter(
    (candidate) => candidate.normalizedName === target
  );

  if (exactMatches.length === 1) {
    return { match: exactMatches[0].option, warning: "" };
  }

  const partialMatches =
    target.length >= 3
      ? candidates.filter((candidate) => {
        return (
          candidate.normalizedName.includes(target) ||
          target.includes(candidate.normalizedName)
        );
      })
      : [];

  if (partialMatches.length === 1) {
    return { match: partialMatches[0].option, warning: "" };
  }

  const fuzzyMatches =
    !exactMatches.length && !partialMatches.length && target.length >= 5
      ? fuzzyCandidates(target, candidates)
      : [];
  const best = fuzzyMatches[0];
  const second = fuzzyMatches[1];
  const hasClearFuzzyMatch =
    best &&
    (!second ||
      best.distance < second.distance ||
      best.similarity - second.similarity >= 0.12);

  if (hasClearFuzzyMatch) {
    return {
      match: best.option,
      warning: "",
    };
  }

  const isAmbiguous =
    exactMatches.length > 1 ||
    partialMatches.length > 1 ||
    fuzzyMatches.length > 1;

  return {
    match: null,
    warning: isAmbiguous
      ? `Намерени са няколко съвпадения за ${locationLabel} „${value}“.`
      : `Не е намерен достъпен ${locationLabel} „${value}“.`,
  };
}
